/**
 * Represents a user in the system
 *
 * @property {string} id - The user's id
 * @property {string} firstName - The user's first name
 * @property {string} lastName - The user's last name
 * @property {string} username - The user's username
 * @property {string} company - The user's company
 * @property {string} email - The user's email
 * @property {string} ipAddress - The user's ip address
 * @property {string} userPicPath - The user's profile picture path
 */
type UserType = {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  company: string;
  email: string;
  ipAddress: string;
  userPicPath: string;
};

/**
 * Represents a user in the system
 *
 * @type {UserType}
 */
const User: UserType = {
  id: "",
  firstName: "",
  lastName: "",
  username: "",
  company: "",
  email: "",
  ipAddress: "",
  userPicPath: "",
};

export { User };
export type { UserType };
